export default __webpack_public_path__ + "static/0174-afb0c35a8ce0f3b47d95461db5b16438.png";